import { Container } from "reactstrap";
import useGetCloudApps from "../../../../api/api-hooks/cloudApps/useGetCloudApps";
import BasicTableView from "../../CloudListView/BasicTableView";
import { useNavigate, useParams } from "react-router-dom";

const empty: [] = [];

export default function CloudAppsList({ urlStart }: { urlStart: string }) {
  const { cloudID } = useParams();
  const { cloudApps, loadingApps } = useGetCloudApps(cloudID);
  const navigate = useNavigate();

  return (
    <Container fluid>
      <BasicTableView
        loading={loadingApps}
        items={cloudApps || empty}
        emptyMessage={"No Cloud Apps Found"}
        titleCSS="tw:rounded-t-md"
        title="Cloud Apps"
        getItemTitle={(a) => a?.Name || a.Title}
        getItemSubtitle={(a) => a.Summary}
        onClick={(a) => navigate(`${urlStart}/${cloudID}/cloudApps/${a.id}`)}
      />
    </Container>
  );
}
